import { Component, Input, OnInit, inject } from '@angular/core';
import { ViewAsClientService } from 'app/core/services/view-as-client.service';
import { Client } from '../../../core/models/client.model';
import { DatePipe } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { BlankValueDashComponent } from '../../../shared/components/blank-value-dash/blank-value-dash.component';
import { PhoneNumberComponent } from '../../../shared/components/phone-number/phone-number.component';
import { JoinListPipe } from '../../../shared/pipes/join-list.pipe';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: 'app-client-list',
    templateUrl: './client-list.component.html',
    styleUrls: ['./client-list.component.scss'],
    imports: [RouterLink,
              RouterLinkActive,
              BlankValueDashComponent,
              PhoneNumberComponent,
              DatePipe,
              JoinListPipe,
              BlankValueDashPipe]
})
export class ClientListComponent implements OnInit {
  private viewAsClientService = inject(ViewAsClientService);

  @Input() clients: Client[];
  @Input() canManageClients: boolean;
  @Input() canManageClientConfigurations: boolean;

  ngOnInit() {}

  clientActive(client): boolean {
    return client && client.status === 'active';
  }

  onViewPortalClick($event, client: Client) {
    this.viewAsClientService.viewAsClient($event, client);
  }

  public assignedUsers(client) {
    const assignedUsers = client.assignedUsers;
    if (assignedUsers && assignedUsers.length > 0) {
      return assignedUsers
        .map(u => u.username)
        .sort()
        .join(', ');
    } else {
      return 'no users assigned';
    }
  }
}
